import { ExpandableImage } from '@/components/expandable-image';
import { Button, Flex, Text, Title } from '@mantine/core';
import { IconCamera, IconReceipt, IconX } from '@tabler/icons-react';

interface DocketPhotoSectionProps {
	docketPhoto: string | null;
	onAddPhoto: () => void;
	onRemovePhoto: () => void;
}

/**
 * Docket photo section
 */
export const DocketPhotoSection: React.FC<DocketPhotoSectionProps> = ({
	docketPhoto,
	onAddPhoto,
	onRemovePhoto,
}) => (
	<Flex direction="column" w="100%" gap="sm">
		<Flex px="md" align="center" justify="space-between" w="100%">
			<Title order={2}>Docket Photo</Title>
		</Flex>

		<Flex px="md" direction="column" gap="md">
			{docketPhoto ? (
				<ExpandableImage id="docket-photo" src={docketPhoto} onDelete={onRemovePhoto} />
			) : (
				<Flex
					style={{ border: '1px dashed var(--mantine-color-gray-6)', borderRadius: '6px' }}
					w="100%"
					p="md"
					direction="column"
					c="gray"
					justify="center"
					align="center"
					gap="sm"
				>
					<IconReceipt size={48} />
					<Text size="md">Add docket photo</Text>
				</Flex>
			)}

			<Flex gap="md">
				{docketPhoto ? (
					<Button
						onClick={onRemovePhoto}
						fullWidth
						variant="filled"
						bg="gray"
						leftSection={<IconX size={16} />}
					>
						Remove Photo
					</Button>
				) : (
					<Button
						onClick={onAddPhoto}
						fullWidth
						variant="filled"
						leftSection={<IconCamera size={16} />}
					>
						Add Photo
					</Button>
				)}
			</Flex>
		</Flex>
	</Flex>
);
